import { render, staticRenderFns } from "./VisitaAngiologicaView.vue?vue&type=template&id=535bce06"
import script from "./VisitaAngiologicaView.vue?vue&type=script&lang=js"
export * from "./VisitaAngiologicaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports